import * as React from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import { getSettingPageMeta } from 'modules/settings/lib/getSettingPageMeta'

import questionsTemplates from 'modules/surveys/store/collections/questionsTemplates'

const SurveySettings = React.lazy(() => import('modules/surveys/pages/settings/SettingsPage'))
const SurveyQuestionsTemplateSettings = React.lazy(
  () => import('modules/surveys/pages/settings/show')
)

const settingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.surveys.path,
      handle: {
        meta: () => getSettingPageMeta(navigation, 'surveys'),
      },
      children: [
        {
          index: true,
          element: <SurveySettings />,
        },
        {
          path: navigation.settings.surveys.template.path,
          element: <SurveyQuestionsTemplateSettings />,
          loader: ({ params }) => {
            return questionsTemplates.fetch({ data: { id: String(params.questionsTemplateId) } })
          },
          handle: {
            meta: ({ params }) => {
              const questionsTemplate = questionsTemplates.get(params.questionsTemplateId)

              return {
                title: questionsTemplate?.attributes.title ?? '',
              }
            },
          },
        },
      ],
    },
  ]
}

export default settingsRoutes
